import React from "react";
import { Grow, Table, TableHead, TableBody, TableCell, TableRow, Grid, TableContainer, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

const tableCellStyle = { color: "#222" };

export default function LocalizationTable(props) {
    const { t } = useTranslation("translation");

    return (
        <Grid container item md={12}>
            <Grid item xs={1} sm={3} md={2}></Grid>
            {/*Empty grid for alignment*/}
            <Grid item xs={10} sm={6} md={8}>
                <div style={{ overflow: "auto", height: "700px" }}>
                    <Table aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">{t("ID")}</TableCell>
                                <TableCell align="center">{t("DefaultName")}</TableCell>
                                <TableCell align="center">
                                    {t("Name")}
                                    {"-TR"}
                                </TableCell>
                                <TableCell align="center">
                                    {t("Name")}
                                    {"-EN"}
                                </TableCell>
                                <TableCell align="center">
                                    {t("Name")}
                                    {"-RU"}
                                </TableCell>
                                <TableCell align="center">
                                    {t("Name")}
                                    {"-RO"}
                                </TableCell>
                                <TableCell align="center">
                                    {t("Name")}
                                    {"-TH"}
                                </TableCell>
                                <TableCell align="center">
                                    {t("Name")}
                                    {"-IT"}
                                </TableCell>
                                <TableCell align="center">
                                    {t("Name")}
                                    {"-PL"}
                                </TableCell>
                                <TableCell align="center">
                                    {t("Name")}
                                    {"-SK"}
                                </TableCell>
                                <TableCell align="center">
                                    {t("Name")}
                                    {"-EG"}
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.localizationExcel.map((row) => (
                                <TableRow style={{ background: row.hasWarning ? "#FF9089" : "aliceblue" }}>
                                    <TableCell sx={tableCellStyle} align="center">{row.id}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.defaultName}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.nameTR}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.nameEN}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.nameRU}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.nameRO}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.nameTH}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.nameIT}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.namePL}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.nameSK}</TableCell>
                                    <TableCell sx={tableCellStyle} align="center">{row.nameEG}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </Grid>
            <Grid container xs={1} sm={3} md={4}>
                {props.warningList.length > 0 && props.localizationExcel.length > 0 ? (
                    <>
                        <Grid item md={2}></Grid>
                        <Grid item md={8}>
                            <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                                <TableContainer component={Paper} style={{ backgroundColor: "#FF9089" }}>
                                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell align="center">{t("Line")}</TableCell>
                                                <TableCell align="center">{t("Warnings")}</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {props.warningList.map((row) => (
                                                <TableRow>
                                                    <TableCell sx={tableCellStyle} align="center">{row.rowNumber - 1}</TableCell>
                                                    <TableCell sx={tableCellStyle} align="center">{row.message}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grow>
                        </Grid>
                        <Grid item md={2}></Grid>
                    </>
                ) : null}
            </Grid>{" "}
            {/*Empty grid for alignment*/}
        </Grid>
    );
}
